import { skipToken } from "@reduxjs/toolkit/query"
import { UUID } from "gen/proto/uuid/models_pb"
import { useMemo } from "react"
import { useIdFilter } from "shared-ts/hooks/useFilter"

import { useListPurchaseOrdersForCustomerQuery } from "features/api/customer"
import { useWebFilter, UseWebFilterProps } from "hooks/filters/useWebFilter"

export const purchaseOrderFilterKey = "purchaseOrder"

const MAX_RENDERED_PURCHASE_ORDERS = 100

interface UsePurchaseOrderFilterProps
  extends Partial<Pick<UseWebFilterProps<unknown>, "persistInUrl" | "key">> {
  customerId?: UUID
}

export function usePurchaseOrderFilter({
  customerId,
  persistInUrl = true,
  key = purchaseOrderFilterKey,
}: UsePurchaseOrderFilterProps = {}) {
  const { currentData } = useListPurchaseOrdersForCustomerQuery(
    customerId ? { customerId } : skipToken
  )
  const purchaseOrders = currentData?.purchaseOrders ?? []

  const { filter, selected: selectedPurchaseOrderIds } = useIdFilter({
    key,
    label: "Purchase Order",
    values: purchaseOrders,
    sort: (a, b) => a.name.localeCompare(b.name),
    labelExtractor: (po) => po.name,
    useFilter: (props) =>
      useWebFilter({
        ...props,
        persistInUrl,
      }),
  })

  const cappedFilter = useMemo(
    () => ({ ...filter, maxRenderedItems: MAX_RENDERED_PURCHASE_ORDERS }),
    [filter]
  )

  return { filter: cappedFilter, selectedPurchaseOrderIds }
}
